module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('site-workflow', {
    attrs: {
      "site-id": _vm.rowData.id,
      "site-name": _vm.rowData.siteName
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8655315c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteWorkflow.vue
// module id = 1670
// module chunks = 0